import { type } from "../utils/util";

export class AuthActions {
  static SET_AUTHENTICATION = type("SET_AUTHENTICATION");
  static SET_AUTHENTICATION_TOKEN = type("SET_AUTHENTICATION_TOKEN");
  static SET_AUTHENTICATION_USER = type("SET_AUTHENTICATION_USER");
  static CLEAR_AUTHENTICATION = type("CLEAR_AUTHENTICATION");
  static PASSWORD_IS_RESET = type("PASSWORD_IS_RESET");
  static ERROR = type("ERROR");
  static ME = type("ME");

  setAuthentication(payload: any = null) {
    return {
      type: AuthActions.SET_AUTHENTICATION,
      payload: payload
    };
  }

  clearAuthentication() {
    return {
      type: AuthActions.CLEAR_AUTHENTICATION
    };
  }

  setPasswordIsReset() {
    return {
      type: AuthActions.PASSWORD_IS_RESET
    };
  }

  setError(payload) {
    return {
      type: AuthActions.ERROR,
      payload: payload
    };
  }

  me(payload) {
    return {
      type: AuthActions.ME,
      payload: payload
    };
  }
}



// WEBPACK FOOTER //
// ./src/states/auth/auth.actions.ts